<template>
  <div class="form-control">
    <label>{{ value.label }}</label>
    <treeselect
      :disableBranchNodes="true"
      ref="tree"
      v-model="value.value"
      :options="value.children"
      v-on:input="updateTreeFacet(value)"
      v-bind:placeholder="value.placeholder">
      <label
        slot="option-label"
        slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
        :class="labelClassName">
        {{ node.label }}
      </label>
    </treeselect>
    <!-- Removed this for now since it was broken before and since replaced with an X that would have to be accounted for.... this module needs to redev -->
    <!-- <span class="bss-icon-chevron-down drop-down-arrow"></span> -->
  </div>
</template>

<script>
 import Treeselect from "@riophae/vue-treeselect";
 import "@riophae/vue-treeselect/dist/vue-treeselect.css";

 export default {
   props: ["value"],
   components: {
     Treeselect
   },
   methods: {
     updateTreeFacet(value) {
       this.$emit("input", value);
     },
   }
 };
</script>
